import styled, { css } from 'styled-components';
import background from '@/media/onboarding/sitebuilder-v2/bg-gradient.svg';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    padding-bottom: 96px;
    width: 100%;
  `}
`;

export const ButtonBackWrapper = styled.div`
  position: absolute;
  left: 26px;
  top: 30px;
  z-index: 10;
`;

export const WaveTop = styled.div`
  ${({ theme }) => css`
    background: url(${background}) no-repeat center top;
    background-size: 100% 300px;
    height: 300px;
    overflow: hidden;
    position: absolute;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      background-size: 100% 180px;
      height: 180px;
    }
  `};
`;

export const CirclesImage = styled.img`
  ${({ theme }) => css`
    height: 320px;
    right: 5vw;
    position: absolute;
    top: -213px;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      top: -60px;
      right: -60px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 144px;
      right: -80px;
    }
  `}
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    height: 400px;
    top: -256px;
    position: absolute;
    left: -3vw;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      left: -40px;
      top: 40px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 144px;
    }
  `};
`;

export const InnerContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 24px;
    position: relative;
    z-index: 2;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0 auto;
      max-width: 632px;
    }
  `}
`;

export const TopBannerTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 56px 0 145px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin: 32px 0 78px;
      max-width: 247px;
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    margin-bottom: 8px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
      margin-bottom: 16px;
    }
  `}
`;

export const Subtitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    margin-bottom: 32px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-bottom: 24px;
    }
  `}
`;

export const WrapperCards = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: 24px 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    border: 1px solid ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 16px;
    box-shadow: 0 4px 4px ${theme.v2.colors.brand.primaryLowLight};
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;
    max-width: 370px;
    padding: 24px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const CardIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 99px;
    display: flex;
    height: 40px;
    justify-content: center;
    width: 40px;
  `}
`;

export const CardTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
  `}
`;

export const CardDesc = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: 1.5;
  `}
`;

export const CardButton = styled.div`
  padding-top: 8px;
  margin-top: auto;

  button {
    gap: 8px;
    padding-left: 16px;
    padding-right: 16px;

    svg {
      flex: 0 0 16px;
      height: 16px;
      width: 16px;
    }
  }
`;
